import { $fontSize, $width, phoneSize } from '@/assets/styles/mediaSize';
import { flexPos } from '@/assets/styles/mixin';
import { mobNavBarHeight, pcNavBarHeight } from '@/assets/styles/var';
import { useServiceSupport } from '@/service/useCustomerService';
import { FC } from 'react';
import styled from 'styled-components';
import Waiting from '../Waiting';
import { isOpenInIFrame } from '@/utils';

const NavbarWrap = styled.header`
  position: relative;
  flex: 0 0 ${mobNavBarHeight}; // height
  padding: 0 34rem;
  ${flexPos('flex-start', 'center')}
  border-bottom: solid 1px #EBEBEB;

  @media (min-width: ${phoneSize}) {
    flex: 0 0 ${pcNavBarHeight}; // height
    padding: 0 48rem;
  }

  .title-text {
    ${isOpenInIFrame() ? `font-size: 14px;` : $fontSize('36rem', '20rem')}
    font-weight: 500;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    @media (min-width: ${phoneSize}) {
      position: static;
      transform: none;
      margin-left: 16rem;
    }
  }

  .icon-customer {
    ${isOpenInIFrame() ? 'width: 24px;' : $width('46rem', '23rem')}
    position: absolute;
    left: auto !important;
    right: 33rem !important;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
`;

const Navbar: FC<{
  title: string;
  onBack?: () => void;
}> = ({ title, onBack }) => {
  const { triggerSupport, loadSupport } = useServiceSupport();

  return (
    <NavbarWrap>
      {!isOpenInIFrame() && (
        <img
          onClick={() => {
            if (onBack) {
              onBack();
            } else {
              window.history.back();
            }
          }}
          src={require('@img/common/icon-arrow.svg')}
          alt=""
          className="w-48 md:w-24 cursor-pointer"
        />
      )}
      <div className="title-text">{title}</div>

      <Waiting isLoading={loadSupport} className="icon-customer">
        <img
          onClick={() => {
            triggerSupport();
          }}
          src={require('@img/chat/icon-customer.svg')}
          alt=""
          className="w-full"
        />
      </Waiting>
    </NavbarWrap>
  );
};

export default Navbar;
